import { Injectable } from '@angular/core';
import { getPVColumns } from './columns.config';
import { StackPlanViewStateService } from '../../state/sp-view-state.service';
import { map } from 'rxjs';

@Injectable()
export class PVColumnResolver {
  constructor(private spViewState: StackPlanViewStateService) {}

  resolve() {
    return this.spViewState.onStateChange$.pipe(map(state => getPVColumns(state).map(c => ({ ...c }))));
  }
}
